import { Pencil, SquareX, CirclePlus } from "lucide-react";
import { useState, useEffect } from "react";
import style from "../../styles/lucide.module.css";
import { useMutation } from "@tanstack/react-query";

const API_URL = process.env.REACT_APP_URL_DIR + "tablagastos";

export default function TablaCrudForm() {
  const token = localStorage.getItem("token");
  const [descripcion, setDescripcion] = useState("");
  const [observ, setObserv] = useState(""); // <-- agregado
  const [tablas, setTablas] = useState([]);
  const [editId, setEditId] = useState(null);
  const [url, setUrl] = useState('');
  const [metodo, setMetodo] = useState('');

  // Obtener datos 
  const fetchTablas = async () => {
    const res = await fetch(API_URL, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    setTablas(data);
  };

  useEffect(() => {
    fetchTablas();
    // eslint-disable-next-line
  }, []);

  // Crear o actualizar
  const handleSubmit = async () => {
    setUrl(API_URL);
    const newPost = {
      id: editId || 0,
      descripcion: descripcion,
       observ: observ, // <-- agregado
    };
    if (newPost.id > 0) {
      setMetodo("PUT");
      setUrl(API_URL + "/" + editId);
    } else {
      setMetodo("POST");
    }
    mutate(newPost);
    setDescripcion("");
    setObserv(""); // <-- limpiar observ
    setEditId(null);
  };

  const { mutate } = useMutation({
    mutationFn: (newPost) =>
      fetch(url, {
        method: metodo,
        body: JSON.stringify(newPost),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }).then((res) => res.json()),
    onSuccess: () => {
      fetchTablas(); // <-- Actualiza la tabla después de grabar
    },
    onError: () => {
      alert("Error");
    },
  });

  // Editar
  const handleEdit = (tabla) => {
    setDescripcion(tabla.descripcion);
     setObserv(tabla.observ || "");
    setEditId(tabla.id);
  };

  // Eliminar
  const handleDelete = async (id) => {
    await fetch(`${API_URL}/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    fetchTablas(); // <-- Actualiza la tabla después de eliminar
  };

  return (
    <div className={style.container}>
      <h2>Tabla de Gastos Fijos</h2>
      <form className={style.form}>
        <div className={style.divedit}>
          <div>
            <input
              className={style.inputDesc}
              type="text"
              placeholder="Descripción"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              required
            />&nbsp;&nbsp;&nbsp;&nbsp;
                  <input
        className={style.inputDesc}
        type="text"
        placeholder="Observaciones"
        value={observ}
        onChange={(e) => setObserv(e.target.value)}
        style={{ marginTop: 8 }}
      />
          </div>
          <div>
            <span
              className="lucideIcon"
              title="Grabar"
              onClick={handleSubmit}
            >
              <CirclePlus />
            </span>
            {editId && (
              <>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span
                  className="lucideIconDel"
                  onClick={() => {
                    setEditId(null);
                    setDescripcion("");
                    setObserv(""); // <-- limpiar observ
                  }}
                >
                  <SquareX />
                </span>
                &nbsp;&nbsp;&nbsp;
              </>
            )}
          </div>
        </div>
      </form>
      <table border="1" cellPadding="8" style={{ width: "100%" }}>
        <thead>
          <tr>
            {/* <th>ID</th> */}
            <th>Descripción</th>
            <th>Observaciones</th> {/* <-- agregado */}
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {tablas?.map((tabla) => (
            <tr key={tabla.id}>
              {/* <td>{tabla.id}</td> */}
              <td>{tabla.descripcion}</td>
              <td>{tabla.observ || ""}</td>
              <td>
                &nbsp;&nbsp;
                <span
                  title="Editar"
                  className="lucideIcon"
                  onClick={() => handleEdit(tabla)}
                >
                  <Pencil />
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span
                  title="Eliminar"
                  className="lucideIconDel"
                  onClick={() => handleDelete(tabla.id)}
                >
                  <SquareX />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}